import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {AuthenticationService} from '@services/authentification.service';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {CommonService} from '@services/common.service';
import {UntypedFormControl} from '@angular/forms';
import {debounceTime, startWith, switchMap} from 'rxjs/operators';
import {City} from '@models/city';
import {environment} from '~/environments/environment';
import {HttpClient} from '@angular/common/http';

@Component({
    selector: 'app-change-city',
    templateUrl: './change-city.component.html',
    styleUrls: ['./change-city.component.scss']
})
export class ChangeCityComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();
    cityControl = new UntypedFormControl();
    cities: City[] = [];

    constructor(
        public authService: AuthenticationService,
        public cityService: CityService,
        public adService: AdService,
        public commonService: CommonService,
        private http: HttpClient) {
    }

    ngOnInit(): void {
        this.cityControl.valueChanges
            .pipe(
                startWith(''),
                debounceTime(500),
                // tap(() => this.isLoading = true),
                switchMap(value => this.cityService.search(this.favorite.ad_city.name))
                // .pipe(finalize(() => this.isLoading = false))
            )
            .subscribe(d => {
                $('.citySpinner').hide();
                this.cities = d;
            });
    }

    changeCity(value) {
        this.http.get<City>(environment.apiUrl + 'app/city/' + value.city_code).subscribe(c => {
            this.favorite.ad_city = c;
            if (this.favorite.ad_city.carac_commune) {
                this.favorite = this.adService.cleanInput(this.favorite);
                this.favorite = this.adService.updateValues(this.favorite);
                this.favoriteChange.emit();
            }
        });
    }
}
